/* eslint-disable no-param-reassign */
import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import { toJS } from 'mobx';
import * as constants from '../../../../common/constants';

const FeedbackDetailedLogModel = types
  .model('FeedbackDetailedLogModel', {
    requestId: types.maybeNull(types.string),
    feedbackId: types.maybeNull(types.string),
    feedback: types.maybeNull(types.string),
    serverDateTime: types.maybeNull(types.string),
    identifierId: types.maybeNull(types.string),
    userId: types.maybeNull(types.string),
    type: types.maybeNull(types.string),
    content: types.maybeNull(types.frozen()),
    comments: types.maybeNull(types.string),
    responseId: types.maybeNull(types.string),
    reasonForDislike: types.maybeNull(types.array(types.string)),
    fromAgentic: types.optional(types.boolean, false),
    displayType: types.maybeNull(types.string),
    botResponseArr: types.maybeNull(types.frozen()),
    botResponse: types.maybeNull(types.frozen()),
    prompt: types.maybeNull(types.frozen()),
    prompts: types.maybeNull(types.frozen()),
    question: types.maybeNull(types.string),
    toolCallOutput: types.maybeNull(types.frozen())
  })
  .views((self) => ({
    get detailedLog() {
      return toJS({
        requestId: self.requestId,
        feedbackId: self.feedbackId,
        feedback: self.feedback,
        serverDateTime: self.serverDateTime,
        identifierId: self.identifierId,
        userId: self.userId,
        type: self.type,
        content: self.content,
        comments: self.comments,
        responseId: self.responseId,
        reasonForDislike: self.reasonForDislike,
        fromAgentic: self.fromAgentic,
        displayType: self.displayType,
        botResponseArr: self.botResponseArr,
        botResponse: self.botResponse,
        prompt: self.prompt,
        prompts: self.prompts,
        question: self.question,
        toolCallOutput: self.toolCallOutput
      });
    },
    get hasData() {
      return self.requestId !== null;
    },
    get reasonForDislikeText() {
      return self.reasonForDislike?.join(', ') || '';
    }
  }))
  .actions((self) => ({
    fetchDetailedLog(requestId, payload) {
      self.resetData();

      Framework.getEventManager().publish(constants.GET_FEEDBACK_DETAILED_LOG, {
        requestId,
        payload
      });
    },
    setResponse(response) {
      if (!response) {
        Framework.getEventManager().publish(constants.GET_FEEDBACK_DETAILED_LOG_RESPONSE);
        return;
      }

      let responseData = null;

      if (response.success !== undefined && response.data) {
        responseData = response.data;
      } else if (response.data) {
        responseData = response.data;
      } else {
        responseData = response;
      }

      if (responseData) {
        const snapshotData = {
          requestId: responseData.requestId || null,
          feedbackId: responseData.feedbackId || null,
          feedback: responseData.feedback || null,
          serverDateTime: responseData.serverDateTime || null,
          identifierId: responseData.identifierId || null,
          userId: responseData.userId || null,
          type: responseData.type || null,
          content: responseData.content || null,
          comments: responseData.comments || null,
          responseId: responseData.responseId || null,
          reasonForDislike: responseData.reasonForDislike || [],
          fromAgentic: responseData.fromAgentic || false,
          displayType: responseData.displayType || null,
          prompt: responseData.prompt || null,
          prompts: responseData.prompts || null,
          question: responseData.question || null,
          toolCallOutput: responseData.toolCallOutput || null
        };

        snapshotData.botResponseArr = responseData.botResponseArr || null;
        snapshotData.botResponse = responseData.botResponse || null;

        applySnapshot(self, snapshotData);
      }

      Framework.getEventManager().publish(constants.GET_FEEDBACK_DETAILED_LOG_RESPONSE);
    },
    resetData() {
      applySnapshot(self, {
        requestId: null,
        feedbackId: null,
        feedback: null,
        serverDateTime: null,
        identifierId: null,
        userId: null,
        type: null,
        content: null,
        comments: null,
        responseId: null,
        reasonForDislike: [],
        fromAgentic: false,
        displayType: null,
        botResponseArr: null,
        botResponse: null,
        prompt: null,
        prompts: null,
        question: null,
        toolCallOutput: null
      });
    },
    resetStoreValues() {
      self.resetData();
      Framework.getEventManager().publish(constants.GET_FEEDBACK_DETAILED_LOG_RESPONSE);
    }
  }));

export default FeedbackDetailedLogModel;
